import { render, staticRenderFns } from "./RendGenericType.vue?vue&type=template&id=411d977e&"
import script from "./RendGenericType.vue?vue&type=script&lang=js&"
export * from "./RendGenericType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports